$(function () {
    const moment = require('moment-timezone');
    const timeZoneName = moment.tz.guess();
    const language = $('html')[0].lang;
    const myProject = require('./_data/myProject');
    const envSettings = myProject[myProject.environment];
    const getRecaptchaToken = require('./recaptchaHelper');

    let prefix;
    switch (language) {
        case "is-en":
        case "is":
            prefix = "youpret_iceland";
            break;
        case "ee":
        case "ee-en":
        case "ee-ru":
        case "et":
            prefix = "youpret_estonia";
            break;
        default:
            prefix = "youpret";
    }
    $.ajaxSetup({
        headers: { "X-TimeZoneName": timeZoneName, "X-Language": language, "X-Prefix": prefix },
        contentType: "application/json; charset=utf-8",
        dataType: "json",
    });

    const Uris = {
        jsonBookingsAdd: envSettings.server + "/json/competitions/addanswer",
        nextPageUri: (() => {
            switch (language) {
                case "fi": return "/fi/kiitos-yhteys/";
                case "sv": return "/sv/tack-kontaktformularet/";
                case "is": return "/is/takk-fyrir-hafdu-samband/";
                case "is-en": return "/is-en/thank-you-contact-form/";
                case "ee":
                case "et": return "/ee/aitah/";
                case "ee-en": return "/ee-en/thank-you-contact-form/";
                case "ee-ru": return "/ee-ru/spasibo/";
                default: return "/en/thank-you-contact-form/";
            }
        })(),
        uri: window.location.pathname
    };

    $("#aiInterpretationForm").on("submit", function (event) {
        event.preventDefault();
        if ($('#aiInterpretationForm')[0].checkValidity()) {
            $("#ai-formSubmit").prop("disabled", true);
            $("#ai-formSubmit").css("background-color", "#6c757d");

            let email = $("#ai-email").val();
            let firstName = $("#ai-firstName").val();
            let lastName = $("#ai-lastName").val();
            let organization = $("#ai-organization").val() || "";
            let moreInfo = $("#ai-moreInfo").val() || "";

            let interests = [];
            $("input[name='interest']:checked").each(function () {
                interests.push($(this).val());
            });

            let infoParts = [];
            if (organization) {
                let orgLabel = "Organisaatio: ";
                if (language === 'ee' || language === 'et') orgLabel = "Organisatsioon: ";
                else if (language === 'sv') orgLabel = "Organisation: ";
                infoParts.push(orgLabel + organization);
            }
            if (interests.length > 0) {
                let intLabel = "Kiinnostukset: ";
                if (language === 'ee' || language === 'et') intLabel = "Huvi: ";
                else if (language === 'sv') intLabel = "Jag är intresserad av: ";
                infoParts.push(intLabel + interests.join(", "));
            }
            if (moreInfo) {
                let infoLabel = "Lisätietoja: ";
                if (language === 'ee' || language === 'et') infoLabel = "Lisainfo: ";
                else if (language === 'sv') infoLabel = "Ytterligare information: ";
                infoParts.push(infoLabel + moreInfo);
            }

            let message = infoParts.join("\n\n");

            let data = {
                email: email,
                firstName: firstName,
                lastName: lastName,
                organizationName: organization,
                additionalInformation: message,
                competitionName: "aiInterpretationPageForm",
                uri: Uris.uri,
                languageCode: language
            };

            getRecaptchaToken().then(function(token) {
                data.recaptchaToken = token;
                $.ajax({
                    url: Uris.jsonBookingsAdd,
                    method: "POST",
                    data: JSON.stringify(data)
                })
                .done(function () {
                    window.location.href = Uris.nextPageUri;
                })
                .fail(function (err) {
                    console.error(err);
                    $("#ai-formSubmit").prop("disabled", false);
                    $("#ai-formSubmit").css("background-color", "");
                });
            });
        } else {
            $('#aiInterpretationForm')[0].reportValidity();
        }
    });

    function toggleSendButtonState() {
        const formValid = $('#aiInterpretationForm')[0].checkValidity();
        if (formValid) {
            $("#ai-formSubmit").prop("disabled", false);
        } else {
            $("#ai-formSubmit").prop("disabled", true);
        }
    }

    $('#aiInterpretationForm input, #aiInterpretationForm textarea').on('input change', toggleSendButtonState);
    toggleSendButtonState();
});
